/**
 * Centralized brand constants for Sirppi
 * Use these constants throughout the app to maintain consistency
 */

export const BRAND = {
  // Core brand names
  name: 'Sirppi',
  registeredName: 'Sirppi®',
  fullName: 'Sirppi.ai',
  domain: 'sirppi.ai',

  // Company info
  foundedYear: 2025,
  market: 'Global',

  // Taglines
  taglines: {
    main: 'A product of Sirppi® — Built for the world 🌍',
    secondary: 'Crafted with purpose. Guided by faith.',
    ecosystem: 'Part of the Sirppi ecosystem',
  },

  // Legal - auto-updates based on current year
  copyright: (year = new Date().getFullYear()) => `© ${year} Sirppi®`,
  copyrightStatic: `© ${new Date().getFullYear()} Sirppi®`,

  // Product-specific
  products: {
    careerPath: {
      name: 'Career Path Explorer',
      tagline: 'Discover your perfect career path',
    },
    careerStudio: {
      name: 'Career Studio',
      tagline: 'Turn your chosen path into reality',
    },
  },

  // Quotes and mission
  quotes: {
    mission: "Career paths are diverse and complex; no single person can know it all. That's why we built Sirppi.ai. An intelligent guide that turns career confusion into clarity.",
    founder: "When I was 15, I had no idea what to pursue. Sirppi.ai is the guide I wish I had. One that understands your context and helps you explore your true potential.",
  },

  // PDF and exports
  pdf: {
    footer: 'Career Path Explorer • Powered by Sirppi®',
    header: 'Sirppi® Career Report',
  },

  // Contact
  contact: {
    supportEmail: 'support@sirppi.ai',
    companyName: 'Sirppi Technologies',
    location: 'Global',
  },
} as const;

export type BrandType = typeof BRAND;
